const map = {
	"./Footer__WiseCursor-Logo Teal.png": 9219,
	"./Header__WiseCursor-Logo Dark.png": 7703,
	"./Header__WiseCursor-Logo Indigo.png": 9425,
	"./Hero__Agentic-Product-World-v1.jpg": 9710,
	"./Hero__Agentic-Product-World-v1.png": 2298,
	"./Hero__Background.png": 2894,
	"./Hero__Background2.jpg": 9114,
	"./Hero__WiseCursorMark Indigo.png": 4493,
	"./Icon__Phone-Santi029-Labtop.svg": 1643,
	"./Icon__Phone.svg": 1397,
	"./Icon__theme-moon.svg": 9072,
	"./Icon__theme-sun-Santi029-Labtop.svg": 8061,
	"./Icon__theme-sun.svg": 8619,
	"./Project__AIDE-OS-Hero.jpg": 6184,
	"./Project__AIDE-OS.jpg": 5361,
	"./Project__AIDE-OS.webp": 7209,
	"./Project__Congress-Compass.webp": 9850,
	"./Project__Endure-AI.webp": 6261,
	"./Project__Handyman-Website.jpg": 4675,
	"./Project__Image-1.jpg": 9046,
	"./Project__Image-2.jpg": 5745,
	"./Project__Image-3.jpg": 7700,
	"./Project__Image-4.jpg": 2639,
	"./Project__Image-5.jpg": 258,
	"./Project__Image-6.jpg": 157,
	"./Project__WiseCursor-360.jpg": 783,
	"./Project__WiseCursor-360.webp": 7997,
	"./Project__WiseCursor-Dashboard-Hero.png": 2741,
	"./Project__WiseCursor-Dashboard.png": 5162,
	"./Project__WiseCursor-UX-Platform.jpg": 1411,
	"./Project__WiseCursor-UX-Platform.webp": 6733,
	"./Project__WiseStocks.jpg": 3834,
	"./Project__WiseStocks.webp": 5566,
	"./Services__card-icon2.svg": 4242,
	"./Services__card-icon3.svg": 6883,
	"./Services__card-icon4.svg": 2844,
	"./Services__card-icon5.svg": 2557,
	"./Services__card-icon6.svg": 3438,
	"./Services__card1.png": 5387,
	"./Services__card2.png": 9984,
	"./Services__card3.png": 5737,
	"./Services__card4.png": 7110,
	"./Services__card5.png": 2207,
	"./Services__card6.png": 9748,
	"./Showreel__Video-Promotion.png": 5928,
	"./Showreel__Video.jpg": 5344,
	"./Support__Human-Approved-AI.jpg": 3009,
	"./Support__Human-Approved-AI.png": 8729,
	"./Support__Interface-System-Design.jpg": 8689,
	"./Support__Interface-System-Design.png": 3881,
	"./Support__Marketing-Team-Brand-Review.jpg": 9050,
	"./Support__Marketing-Team-Brand-Review.png": 1438,
	"./Support__Operations-Workflow-Review.jpg": 8148,
	"./Support__Operations-Workflow-Review.png": 1952,
	"./Support__Product-Strategy-Workshop.jpg": 4744,
	"./Support__Product-Strategy-Workshop.png": 1084,
	"./Support__Product-Team-Workshop.jpg": 2508,
	"./Support__Product-Team-Workshop.png": 5880,
	"./Welcome__WiseCursorMark_White.png": 6995,
	"./Wl-Footer__Social1.svg": 7827,
	"./Wl-Footer__Social2.svg": 3168,
	"./Wl-Footer__Social3.svg": 1201,
	"./Wl-Footer__icon.svg": 240,
	"./Wl-Form__@.svg": 8816,
	"./Wl-Form__Background.jpg": 5944,
	"./Wl-Form__Scroll_Icon.svg": 5413,
	"./Wl-Form__WiseCursorMark White.png": 7698,
	"./Wl-Header__WiseCursor-Logo White.png": 9664,
	"./Wl-Services__card-icon1 - Copy.svg": 1405,
	"./Wl-Services__card-icon1.svg": 2271,
	"./Wl-Services__card-icon2.svg": 3244,
	"./Wl-Services__card-icon3.svg": 605,
	"./Wl-Services__card-icon4.svg": 2082,
	"./Wl-Services__card-icon5.svg": 5811,
	"./Wl-Services__card-icon6.svg": 4800,
	"./Wl-Services__card1.png": 5623,
	"./Wl-Services__card2.png": 2972,
	"./Wl-Services__card3.png": 8885,
	"./Wl-Services__card4.png": 5114,
	"./Wl-Services__card5.png": 2867,
	"./Wl-Services__card6.png": 6008,
	"./Wl-Why__card1.svg": 3795,
	"./Wl-Why__card2.svg": 8656,
	"./Wl-Why__card3.svg": 897,
	"./Wl-Why__card4.svg": 5614,
	"./btn__primary-left-arrow dark.png": 8366,
	"./btn__primary-left-arrow light.png": 8688,
	"./btn__primary-right-arrow dark.png": 4841,
	"./btn__primary-right-arrow light.png": 3657,
	"./facebook-black 1.png": 3211,
	"./figma-home/footer-owl.jpg": 4345,
	"./figma-home/header-menu-burger.svg": 6616,
	"./figma-home/hero-owl.svg": 9960,
	"./figma-home/home-hero.jpg": 9715,
	"./figma-home/home-showreel.jpg": 6576,
	"./figma-home/pricing-basic.svg": 1396,
	"./figma-home/pricing-pro.svg": 9767,
	"./figma-home/pricing-vip.svg": 2411,
	"./figma-home/project-1.jpg": 1724,
	"./figma-home/project-2.jpg": 3707,
	"./figma-home/project-3.jpg": 5662,
	"./figma-home/service-1.jpg": 1090,
	"./figma-home/service-2.jpg": 5245,
	"./figma-home/service-3.jpg": 7152,
	"./figma-home/service-4.jpg": 7315,
	"./figma-home/service-5.jpg": 2550,
	"./figma-home/service-6.jpg": 4689,
	"./figma-home/showreel-icon-text.png": 24,
	"./linkedin-black 1.png": 6605,
	"./messenger-black 1.png": 8992,
	"./offer tag.png": 2328,
	"./project-galleries/aide-desktop-shell.jpg": 108,
	"./project-galleries/aide-onboarding-complete.jpg": 6112,
	"./project-galleries/aide-privacy-controls.jpg": 5066,
	"./project-galleries/aide-status-panel.jpg": 5094,
	"./project-galleries/aide-voice-entry.jpg": 2696,
	"./project-galleries/aide-workflow-preferences.jpg": 3459,
	"./project-galleries/congress-compass/01-home.webp": 6024,
	"./project-galleries/congress-compass/02-directory.webp": 5139,
	"./project-galleries/congress-compass/03-profile.webp": 7610,
	"./project-galleries/congress-compass/04-compare.webp": 4765,
	"./project-galleries/congress-compass/05-solution.webp": 3016,
	"./project-galleries/congress-compass/06-about.webp": 29,
	"./project-galleries/dashboard-analytics.png": 946,
	"./project-galleries/dashboard-build-progress.png": 1596,
	"./project-galleries/dashboard-overview.png": 9653,
	"./project-galleries/dashboard-recovery-inbox.png": 1150,
	"./project-galleries/dashboard-registry.png": 7969,
	"./project-galleries/dashboard-security-center.png": 7078,
	"./project-galleries/endure-ai/01-landing-journey.webp": 4250,
	"./project-galleries/endure-ai/02-dashboard-dark.webp": 3352,
	"./project-galleries/endure-ai/03-nutrition-flow.webp": 9805,
	"./project-galleries/endure-ai/04-dashboard-concept.webp": 5862,
	"./project-galleries/endure-ai/05-flow-hero.webp": 9264,
	"./project-galleries/endure-ai/06-flow-pillars.webp": 1903,
	"./project-galleries/handyman-client-expectations.png": 5301,
	"./project-galleries/handyman-estimate-form.png": 655,
	"./project-galleries/handyman-example-projects.png": 2141,
	"./project-galleries/handyman-hero.png": 6108,
	"./project-galleries/handyman-process.png": 345,
	"./project-galleries/handyman-service-categories.png": 914,
	"./project-galleries/scanner-analysis.png": 7576,
	"./project-galleries/scanner-progress.png": 2211,
	"./project-galleries/scanner-report.png": 8208,
	"./project-galleries/scanner-review-setup.png": 3178,
	"./project-galleries/scanner-url-entry.png": 4376,
	"./project-galleries/scanner-validation.png": 1067,
	"./project-galleries/wisestocks-account-creation.jpg": 6978,
	"./project-galleries/wisestocks-account-login.jpg": 8894,
	"./project-galleries/wisestocks-planning-hero.jpg": 8623,
	"./project-galleries/wisestocks-planning-steps.jpg": 3874,
	"./project-galleries/wisestocks-security-trust.jpg": 2076,
	"./project-galleries/wisestocks-strategy-comparison.jpg": 9404,
	"./twitter-black 1.png": 944,
	"./whatsapp-black 1.png": 6133,
	"./wisecursor-hero/hero-abstract.jpg": 1187,
	"./wisecursor-hero/hero-ai.jpg": 5723,
	"./wisecursor-hero/hero-ai.webp": 3837,
	"./wisecursor-hero/hero-mountain.jpg": 8332,
	"./wisecursor-hero/hero-security.jpg": 5015,
	"./youtube-black 1.png": 8126
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3833;